import React, { useMemo } from "react";
import { Controller } from "react-hook-form";
import SearchableSelect from "../../ui/SearchableSelect";

const VehicleSection = ({
  register,
  watch,
  control,
  vehicleModes,
  vehicleTypes,
  filteredVehicles,
  validationErrors,
  errors,
}) => {

  const vehicleMode = watch("vehicle_mode");
  const VEHICLE_OTHERS = {
    id: 0,
    vehicle_number: 'Others',
    vehicle_type: {
      name: 'NA'
    }
  }

  const vehicleList = useMemo(() => {
    if (!vehicleMode) return [];

    const vehicles = filteredVehicles.filter(
      v => v.vehicle_mode === vehicleMode
    );

    if (vehicleMode === "market") {
      return [...vehicles, VEHICLE_OTHERS];
    }

    return vehicles;

  }, [vehicleMode, filteredVehicles]);

  return (
    <section>
        {/* <h3 className="text-sm font-semibold mb-2">Vehicle Information</h3> */}
        <div className="grid md:grid-cols-3 mb-4 gap-4">
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Vehicle Mode</label>
            <select
              {...register("vehicle_mode")}
              className="border rounded p-2 text-sm w-full"
            >
              {vehicleModes.map((vm) => (
                <option key={vm.id} value={vm.id}>{vm.value}</option>
              ))}
            </select>
            {errors.vehicle_mode && (
              <p className="text-red-500 text-sm mt-1">{errors.vehicle_mode[0]}</p>
            )}
          </div>
          <div className="flex flex-col">
            <label className="text-xs text-gray-600 mb-1">Vendor Name</label>
            <input
                {...register("vendor_name")}
                type="text"
                className="border rounded p-2 text-sm w-full"
              />
            {errors.vendor_name && (
              <p className="text-red-500 text-sm mt-1">{errors.vendor_name[0]}</p>
            )}
          </div>

          {/* {watch("vehicle_mode") === "market" && (
            <div className="flex flex-col">
              <div className="flex flex-col">
                <label className="text-xs text-gray-600 mb-1">Requested Vehicle</label>
                <select
                  {...register("requested_vehicle_id", {valueAsNumber: true})}
                  className="border rounded p-2 text-sm w-full"
                >
                  <option value={0}>Select Vehicle</option>
                  {vehicleTypes.map((vt) => (
                    <option key={vt.id} value={vt.id}>{vt.name}</option>
                  ))}
                </select>
                {errors.requested_vehicle && (
                  <p className="text-red-500 text-sm mt-1">{errors.requested_vehicle[0]}</p>
                )}
              </div>
            </div>
          )} */}
        </div>
        <div className="grid md:grid-cols-3 gap-4">
            <div className="flex flex-col">
              <label className="text-xs text-gray-600 mb-1">Requested/Assigned Vehicle</label>
              <select
                {...register("requested_vehicle_id", {valueAsNumber: true})}
                className="border rounded p-2 text-sm w-full"
              >
                <option value={0}>Select Vehicle</option>
                {vehicleTypes.map((vt) => (
                  <option key={vt.id} value={vt.id}>{vt.name}</option>
                ))}
              </select>
              {errors.requested_vehicle && (
                <p className="text-red-500 text-sm mt-1">{errors.requested_vehicle[0]}</p>
              )}
            </div>
            <div className="flex flex-col">
              <label className="text-xs text-gray-600 mb-1">Vehicle</label>
              <Controller
                name="assigned_vehicle_id"
                control={control}
                render={({ field }) => (
                  <SearchableSelect
                    value={field.value}
                    onChange={field.onChange}
                    options={vehicleList}
                    placeholder="Select Vehicle"
                    getOptionLabel={(v) => `${v.vehicle_number} | ${v.vehicle_type?.name ?? ''}`}
                    getOptionValue={(v) => String(v.id)}
                    searchPlaceholder="Search by vehicle number..."
                    error={errors.assigned_vehicle?.[0]}
                  />
                )}
              />
              {errors.assigned_vehicle && (
                <p className="text-red-500 text-sm mt-1">{errors.assigned_vehicle[0]}</p>
              )}
            </div>
            {watch("vehicle_mode") === "own" && (
              <div className="flex flex-col">
                <label className="text-xs text-gray-600 mb-1">Remarks</label>
                <input
                  {...register("vehicle_selection_remarks")}
                  type="text"
                  className="border rounded p-2 text-sm w-full"
                />
                {errors.vehicle_selection_remarks && (
                  <p className="text-red-500 text-sm mt-1">{errors.vehicle_selection_remarks[0]}</p>
                )}
                {validationErrors.vehicle_selection_remarks && (
                  <p className="text-red-500 text-sm mt-1">{validationErrors.vehicle_selection_remarks}</p>
                )}
              </div>
            )}
            {watch("vehicle_mode") === "market" && (
              <>
                <div className="flex flex-col">
                  <label className="text-xs text-gray-600 mb-1">Vehicle Number</label>
                  <input
                    {...register("vehicle_number", {
                      onChange: (e) => {
                        e.target.value = String(e.target.value || "")
                          .toUpperCase()
                          .replace(/\s+/g, "");
                      },
                    })}
                    type="text"
                    className="border rounded p-2 text-sm w-full"
                  />
                  {errors.vehicle_number && (
                    <p className="text-red-500 text-sm mt-1">{errors.vehicle_number[0]}</p>
                  )}
                </div>
                <div className="flex flex-col">
                  <label className="text-xs text-gray-600 mb-1">Vehicle Type</label>
                  <select
                    {...register("vehicle_type_id", {valueAsNumber: true})}
                    className="border rounded p-2 text-sm w-full"
                  >
                    <option value={0}>Select Vehicle</option>
                    {vehicleTypes.map((vt) => (
                      <option key={vt.id} value={vt.id}>{vt.name}</option>
                    ))}
                  </select>
                  {errors.vehicle_type && (
                    <p className="text-red-500 text-sm mt-1">{errors.vehicle_type[0]}</p>
                  )}
                </div>
              </>
            )}
          {/* {watch("vehicle_mode") === "market" && (
            <>
              <div className="flex flex-col">
                <label className="text-xs text-gray-600 mb-1">Vehicle Number</label>
                <input
                  {...register("vehicle_number")}
                  type="text"
                  className="border rounded p-2 text-sm w-full"
                />
                {errors.vehicle_number && (
                  <p className="text-red-500 text-sm mt-1">{errors.vehicle_number[0]}</p>
                )}
                {validationErrors.vehicle_number && (
                  <p className="text-red-500 text-sm mt-1">{validationErrors.vehicle_number}</p>
                )}
              </div>

              <div className="flex flex-col">
                <label className="text-xs text-gray-600 mb-1">Vehicle Type</label>
                <input
                  {...register("vehicle_type")}
                  type="text"
                  className="border rounded p-2 text-sm w-full"
                />
                {errors.vehicle_type && (
                  <p className="text-red-500 text-sm mt-1">{errors.vehicle_type[0]}</p>
                )}
              </div>

              <div className="flex flex-col">
                  <label className="text-xs text-gray-600 mb-1">Vehicle Capacity</label>
                  <input
                    {...register("vehicle_capacity")}
                    type="text"
                    className="border rounded p-2 text-sm w-full"
                  />
                {errors.vehicle_capacity && (
                  <p className="text-red-500 text-sm mt-1">{errors.vehicle_capacity[0]}</p>
                )}
              </div>
            </>
          )} */}
        </div>

    </section>
  );
};

export default VehicleSection;
